import { Popup } from "./class";

const menuPopup = new Popup(".menu-popup", {
  openButtons: ".header__burger",
  closeButton: ".menu-popup__close",
  closeOnResize: true,
  on: {
    open() {
      this.element.setAttribute("aria-hidden", "false");
      this.openButtons.forEach((button) => {
        button.setAttribute("aria-expanded", "true");
      });
    },
    close() {
      this.element.setAttribute("aria-hidden", "true");
      this.openButtons.forEach((button) => {
        button.setAttribute("aria-expanded", "false");
      });
    },
  },
});

const menuPopupLinks = document.querySelectorAll(".menu-popup .nav-list a");

menuPopupLinks.forEach((link) => {
  link.addEventListener("click", () => {
    menuPopup.close();
  });
});

const APPLICATION_POPUP_SUBMITTED_KEY = "application_popup_submitted";
const APPLICATION_POPUP_SHOWN_KEY = "application_popup_shown";

const applicationPopupElement = document.querySelector(".application-popup");
const applicationPopupButtons = Array.from(
  document.querySelectorAll("[data-application-popup-open]")
);
const applicationPopupAutoplayDelay = 30000;
let applicationPopupScrollPosition = 0;

/**
 * Returns true if the user has already submitted the application form.
 */
const hasApplicationPopupBeenSubmitted = () => {
  try {
    return localStorage.getItem(APPLICATION_POPUP_SUBMITTED_KEY) === "1";
  } catch {
    return false;
  }
};

const hasApplicationPopupBeenShown = () => {
  try {
    return sessionStorage.getItem(APPLICATION_POPUP_SHOWN_KEY) === "1";
  } catch {
    return false;
  }
};

const markApplicationPopupAsShown = () => {
  try {
    sessionStorage.setItem(APPLICATION_POPUP_SHOWN_KEY, "1");
  } catch {
    // sessionStorage not available - silently ignore
  }
};

/**
 * Marks the application form as submitted in localStorage.
 */
const markApplicationPopupAsSubmitted = () => {
  try {
    localStorage.setItem(APPLICATION_POPUP_SUBMITTED_KEY, "1");
  } catch {
    // localStorage not available — silently ignore
  }
};

if (applicationPopupElement) {
  const applicationPopup = new Popup(".application-popup", {
    closeButton: ".application-popup__close",
    on: {
      open() {
        markApplicationPopupAsShown();
        this.element.setAttribute("aria-hidden", "false");
        applicationPopupScrollPosition =
          window.scrollY || document.documentElement.scrollTop || 0;
        document.documentElement.classList.add("is-application-popup-open");
        document.body.classList.add("is-application-popup-open");
        document.body.style.top = `-${applicationPopupScrollPosition}px`;
        applicationPopupButtons.forEach((button) => {
          button.setAttribute("aria-expanded", "true");
        });
      },
      close() {
        this.element.setAttribute("aria-hidden", "true");
        document.documentElement.classList.remove("is-application-popup-open");
        document.body.classList.remove("is-application-popup-open");
        document.body.style.top = "";

        const previousScrollBehavior = document.documentElement.style.scrollBehavior;
        document.documentElement.style.scrollBehavior = "auto";
        window.scrollTo(0, applicationPopupScrollPosition);
        document.documentElement.style.scrollBehavior = previousScrollBehavior;

        applicationPopupButtons.forEach((button) => {
          button.setAttribute("aria-expanded", "false");
        });
      },
    },
  });

  applicationPopupButtons.forEach((button) => {
    button.setAttribute("aria-haspopup", "dialog");
    button.setAttribute("aria-expanded", "false");

    button.addEventListener("click", (event) => {
      event.preventDefault();
      applicationPopup.open();
    });
  });

  // Keep the popup title in sync with the temporary success message.
  const titleEl = applicationPopupElement.querySelector("[data-application-popup-title]");
  const formContainer = applicationPopupElement.querySelector(".application-popup__form");

  if (formContainer && titleEl) {
    const syncPopupTitle = () => {
      const successEl = formContainer.querySelector(".reintegration-form__success");
      const successStyles = successEl ? window.getComputedStyle(successEl) : null;
      const isSuccessVisible = Boolean(
        successEl &&
        !successEl.hidden &&
        successStyles.display !== "none" &&
        successStyles.visibility !== "hidden"
      );

      titleEl.classList.toggle("is-hidden-after-submit", isSuccessVisible);

      if (isSuccessVisible) {
        markApplicationPopupAsSubmitted();
      }
    };

    const successObserver = new MutationObserver(syncPopupTitle);

    successObserver.observe(formContainer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style", "class"],
    });

    syncPopupTitle();
  }

  const openApplicationPopupAfterDelay = () => {
    // Do not auto-open if the user already submitted or saw the form in this session.
    if (hasApplicationPopupBeenSubmitted() || hasApplicationPopupBeenShown()) {
      return;
    }

    if (applicationPopupElement.hasAttribute("open")) {
      return;
    }

    applicationPopup.open();
  };

  window.addEventListener("load", () => {
    setTimeout(openApplicationPopupAfterDelay, applicationPopupAutoplayDelay);
  });
}
